"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultCacheStorage = void 0;
var offix_scheduler_1 = require("offix-scheduler");
exports.createDefaultCacheStorage = function () {
    return new offix_scheduler_1.IDBLocalStore("apollo-cache", "cache-store");
};
